import React, { Component , useEffect} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PathSeparator from './PathSeparator';
import AWS from 'aws-sdk';
import {Spinner} from '../Spinner'
export default class NodeLink extends Component {
  static propTypes = {
    node: PropTypes.shape({
      path: PropTypes.string,
      url: PropTypes.string,
      children: PropTypes.array,
      accessKeyId: PropTypes.string,
      secretAccessKey: PropTypes.string,
      bucket: PropTypes.string
    }).isRequired,
  }

  state = {
    flag: false
  }

  loading = () => {
    this.setState({
      flag: !this.state.flag
    })
  }


  render() {
    const { node, children, accessKeyId, secretAccessKey, bucket} = this.props;
   
    const handleDownload = async (fileName) => {
      // Replace with the actual file name
    this.loading()
     try {
       const blob = await downloadFileAsBlob(fileName, bucket);
 
       // Create a temporary URL for the blob
       const url = URL.createObjectURL(blob);
 
       // Trigger file download
       const link = document.createElement('a');
       link.href = url;
       link.download = fileName;
       document.body.appendChild(link);
       link.click();
       document.body.removeChild(link);
 
       // Clean up the temporary URL
       URL.revokeObjectURL(url);
     } catch (error) {
       console.error('Error downloading file:', error);
     }
   };
 
   const downloadFileAsBlob = (fileName, bucketName) => {
    const s3 = new AWS.S3({
      accessKeyId,
      secretAccessKey,
    });
    console.log(node, bucketName)
    const params = {
      Bucket: bucketName,
      Key: fileName
    };
  
    return new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          reject(err);
          this.loading();
        } else {
          const blob = new Blob([data.Body]);
          resolve(blob);
          this.loading();
        }
      });
    });
    
  };
      if (node.children) {
        return (
          <a><span>
             <Link to={node.path}>{children}</Link>
            <PathSeparator />
          </span></a>
        );
      } else {
        return(
          <span>
            {node.path !== node.key && <a>{children}</a>}
          </span>
        );
      }
    
  }
}
